import { daysBetween } from '../../dates/index.js';
/** `today` is the Pacific business date; a license expiring today has 0 days left. */
export function daysUntilLicenseExpiry(expiresAt, today) {
    return daysBetween(today, expiresAt);
}
//# sourceMappingURL=days-until-license-expiry.js.map